'use client';

import React, { useState } from 'react';

import { Link } from '@/i18n/routing';

type NavigationItemMenuProps = {
    trigger: React.JSX.Element;
    href: string;
    items: Array<{
        text: string;
        href: string;
    }>;
};

const NavigationItemMenu: React.FC<NavigationItemMenuProps> = ({ trigger, href, items }) => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    // trick to prevent menu closing because of not being hovered on the menu margin
    const menuMarginPx = '10';

    return (
        <div
            className="relative"
            role="menu"
            tabIndex={0}
            onFocus={() => setIsPanelOpen(true)}
            onMouseEnter={() => setIsPanelOpen(true)}
            onMouseLeave={() => setIsPanelOpen(false)}>
            {trigger}
            <div className={`absolute top-full left-0 w-full h-${menuMarginPx} bg-transparent`} />
            {isPanelOpen && (
                <div
                    className={`absolute z-[60] mt-[${menuMarginPx}px] flex right-0 flex-col rounded-8 bg-white overflow-hidden`}>
                    {items.map((item) => (
                        <Link
                            onClick={() => setIsPanelOpen(false)}
                            key={item.href}
                            href={`${href}#${item.href}`}
                            className="py-8 px-16 text-darkBlue text-body-14 hover:bg-gray-light whitespace-nowrap">
                            {item.text}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NavigationItemMenu;
